"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jquery_1 = __importDefault(require("jquery"));
const HeaderUI_1 = require("./UI/HeaderUI");
const SystemPanel_1 = require("./UI/SystemPanel");
const UnityLoaderSetup_1 = require("./utils/UnityLoaderSetup");
require("./scss/styles.scss");
require('../node_modules/jquery-ui-dist/jquery-ui.min.js');
require('../node_modules/jquery-ui-dist/jquery-ui.min.css');
console.log("Build date:", __BUILD_DATE__);
/** Create UI */
(0, jquery_1.default)(function () {
    (0, UnityLoaderSetup_1.LoadUnity)();
    (0, HeaderUI_1.Header)();
    (0, SystemPanel_1.SystemPanelInit)();
    // add build date bottom right
    (0, jquery_1.default)('body').append(`<div style="position: fixed; bottom: 5px; right: 5px; font-size: 10px; color: #888;">Build date: ${__BUILD_DATE__}</div>`);
});
